const reviewsSlider = document.querySelector(
  '.reviews-slider .reviews-slider__slider'
)

if (reviewsSlider) {
  initializeSlider(
    '.reviews-slider__slider',
    {
      slidesPerView: 3,
      spaceBetween: 14,
      speed: 600,
      loop: true,
      autoHeight: false,
      navigation: {
        nextEl: '.reviews-slider__arrows .next',
        prevEl: '.reviews-slider__arrows .prev',
        clickable: true,
      },
      breakpoints: {
        250: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        500: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        550: {
          slidesPerView: 1.4,
          spaceBetween: 10,
        },
        680: {
          slidesPerView: 1.8,
        },
        900: {
          slidesPerView: 2,
        },
        1100: {
          slidesPerView: 3,
        },
      },
    },
    { breakpoint: 'all' }
  )
}

// ----------------------------------------------------------------------

const testimonialSlider = document.querySelector(
  '.testimonials-slider .testimonials-slider__slider'
)

if (testimonialSlider) {
  initializeSlider(
    '.testimonials-slider__slider',
    {
      slidesPerView: 3,
      spaceBetween: 18,
      speed: 600,
      loop: true,
      autoHeight: false,
      navigation: {
        nextEl: '.next',
        prevEl: '.prev',
        clickable: true,
      },
      breakpoints: {
        250: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        500: {
          slidesPerView: 1.1,
          spaceBetween: 10,
        },
        550: {
          slidesPerView: 1.4,
          spaceBetween: 10,
        },
        680: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
      },
    },
    { breakpoint: 'all' }
  )
}

// ----------------------------------------------------------------------

function initializeSlider(selector, options, breakpoints) {
  let sliderInstance = null

  function initSlider() {
    sliderInstance = new Swiper(selector, options)
  }

  function destroySlider() {
    if (sliderInstance) {
      sliderInstance.destroy()
      sliderInstance = null
    }
  }

  function handleMobileSlider() {
    let isMobile
    if (breakpoints.breakpoint === 'all') {
      isMobile = true
    } else {
      isMobile = window.innerWidth <= breakpoints.breakpoint
    }

    if (isMobile && !sliderInstance) {
      initSlider()
    } else if (!isMobile && sliderInstance) {
      destroySlider()
    }
  }

  handleMobileSlider()
  window.addEventListener('resize', handleMobileSlider)
}
